import React, { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import moment from "moment";
import FileSaver from "file-saver";
import { toast } from "react-hot-toast";
import { connect } from "react-redux";
import { NewDownloadIcon } from "../../../assets/images";
import { RootState } from "../../../redux/rootReducers";
import { LoginResponseType } from "../../../redux/auth/authTypes";
import { DropdownToggle } from "reactstrap";
import { downloadUserOpenJobsReportApi } from "../../../apis/jobsApis";


type AppProps = {
  loginData?: LoginResponseType;
  searchTerm:string;
  token?: string | null;
}
const DownloadOpenItemReport = ({ 
  token,
  loginData,
  searchTerm
}: AppProps) => {
  const handlePrepareDownload = () => {
    let params: any = {
      "user_id": loginData?.user_id,
      token,
      search_term:searchTerm ? searchTerm : ""
    };

    if (params && token) {
      handleDownload(params);
    }
  };

  const handleDownload = (params: any) => {
    
    let name = loginData?.first_name + "_" + loginData?.last_name;
    let reportName = name ? name + "_" + "all_open_jobs"
      + "_" + moment().format('DD-MM-YYYY') +
      ".xlsx"
      : "report";
      downloadUserOpenJobsReportApi(params).then((response: any) => {

      let blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8" });
      FileSaver.saveAs(blob, reportName);
      toast.success("Report Downloaded Successfully!", {
        duration: 3000,
      });
    });
  }

  return (

    <OverlayTrigger
      placement="bottom"
      delay={{ show: 250, hide: 250 }}
      overlay={
        <Tooltip id="button-view-download-invoice">Download Reports</Tooltip>
      }
    >
     
      <button className="btn btn-light" style={{border:"1px solid #6e7491"}} onClick={() => handlePrepareDownload()}>
        <img src={NewDownloadIcon} alt="download icon" />
      </button>

    </OverlayTrigger>
  );
};


const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  loginData: state.auth.loginData
});


export default connect(
  mapStateToProps,
)(DownloadOpenItemReport);
